import { setNavigateTo } from "../../../features/global/globalSlice.js";
import store from "../../../store/store.js";
export const handleLeave = () => {
  store.dispatch(setNavigateTo("/game-lobby"));
};
